exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-module__transition___3w8cn {\n  display: block;\n  position: relative;\n  width: 100%;\n}\n\n.index-module__container___1LVzR {\n  display: block;\n  position: fixed;\n  z-index: 7;\n  width: 100%;\n}\n", ""]);
// Exports
exports.locals = {
	"transition": "index-module__transition___3w8cn",
	"container": "index-module__container___1LVzR"
};